import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, Renderer2, HostListener} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import 'rxjs/add/operator/filter';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {HotService} from "../services/hot.service";
import {IAlert} from "../tools/alert/alert.service";
import {TranslateService} from "@ngx-translate/core";
import {Lang} from "../tools/lang";


@Component({
    selector: 'about-text-carusel',
    templateUrl: './text.carusel.component.html',
    styleUrls: [
        './text.carusel.component.less'],
    animations: [
        trigger("TextBox", [
            state('current', style({
                opacity: '1',
            })),
            state('prev', style({
                opacity: '0',
            })),
            state('next', style({
                opacity: '0',
            })),
            transition('prev => current', [
                animate('1s ease-out')
            ]),
            transition('current => next', [
                animate('1s ease-out')
            ]),
            transition('next => current', [
                animate('1s ease-out')
            ])

        ])]

})
export class TextCaruselComponent implements OnInit, OnDestroy {

    @ViewChild('TextContainer') textContainer: ElementRef;

    // @Input() mode: string;

    constructor(
        private readonly translate: TranslateService,
        public router: Router,
        public activatedRoute: ActivatedRoute,
    ) {
        this.setTextList();
        // if (this.textList.length) {
        //     this.textList.map((p,index) => {
        //         p.state = (p.counter == 0) ? 'current' : (p.counter == 2) ? 'next' : 'prev';
        //         p.left = this.SetLeft(p.state,index);
        //     })
        // }
    }

    ngAfterViewInit() {

        // this.setLeftList();
    }

    /**
     *  SUBSCRIBERS
     */
    ngOnInit() {
        this.currLang$ = this.translate.getDefaultLang();

        this.translateSubscription = this.translate.onLangChange
            .subscribe(p => {
                this.currLang$ = this.translate.currentLang;
            });
        this.timer = window.setTimeout(this.ChangeState.bind(this), this.delay);
    }

    ngOnDestroy() {
        this.translateSubscription.unsubscribe();
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    public currLang$: string;
    private translateSubscription: any;
    public currentLeft = 0;

    setTextList() {
        this.textList = [];
        [0, 1, 2].map((p, index) => {
            let tst = <ITextItem>{};
            tst.counter = index;
            tst.state = (p == 0) ? 'current' : (p == 2) ? 'next' : 'prev';
            // tst.left = this.SetLeft(tst.state,index);
            this.textList.push(tst);
        });
        // console.log(this.textContainer, this.textList)
    }

    // setLeftList() {
    //     this.textList.map((p, index) => {
    //         p.left = this.SetLeft(p.state, index);
    //     });
    //     console.log(this.textContainer, this.textList)
    // }


    public getLangId(lang) {
        return 1; // TODO: переделать при подключении локализации
    }

    public textList: ITextItem[];
    public timer;
    public delay = 8000;

    // private SetLeft(state, index) {
        // let left = 0;
        // if (this.textList.length) {
        //     switch (state) {
        //         case 'current':
        //             left = 0 - (this.textContainer.nativeElement.clientWidth / 3) * index;
        //             break;
        //         case 'next':
        //             left = -this.textContainer.nativeElement.clientWidth / 3 - (this.textContainer.nativeElement.clientWidth / 3) * index;
        //             break;
        //         case 'prev':
        //             left = this.textContainer.nativeElement.clientWidth / 3 - (this.textContainer.nativeElement.clientWidth / 3) * index;
        //             break;
        //         default:
        //             left = 0;
        //     }
        // }
        // return left;
    // }

    public ChangeState() {
        if (this.textList.length) {
            this.textList.map((p, index) => {
                p.state = (p.state == 'prev') ? 'current' : (p.state == 'current') ? 'next' : 'prev';
                // p.left = this.SetLeft(p.state, index);
            })
        this.currentLeft = (this.currentLeft == 2) ? 0 : this.currentLeft + 1;
            this.timer = window.setTimeout(this.ChangeState.bind(this), this.delay);
        }
    }

    public onChangeState(item) {
        if (this.textList.length) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.textList[(item.counter)].state = 'current';
            this.textList[(item.counter) > 0 ? Number(item.counter) - 1 : 2].state = 'next';
            this.textList[(item.counter) < 2 ? Number(item.counter) + 1 : 0].state = 'prev';

            this.textList.map((p, index) => {
                // p.left = this.SetLeft(p.state, index);
            })

            this.currentLeft = item.counter;

            this.timer = window.setTimeout(this.ChangeState.bind(this), this.delay);
        }
    }

    public onGoTo(item) {
        if (item.link) {
            if (item.link.substr(0, 1) == '/') {
                this.router.navigate([item.link]);
            } else {
                window.open(item.link, '_blank');
            }
        }
    }
}


export interface ITextItem {
    id: number;
    content: any;
    state: string;
    left: number;
    link: string;
    counter: number;
}
